export default "__VITE_ASSET__oltPi_9c__"